document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();

        // Ocultar boton avisar stock al inicio, o sino se ha seleccionado talla
        const bisButton = document.getElementById('BIS_trigger');
          if (bisButton) {
            bisButton.style.display = 'none';
            bisButton.style.visibility = 'hidden';
            bisButton.style.opacity = '0';
            bisButton.style.pointerEvents = 'none';
            bisButton.setAttribute('hidden', true);
          }


      
        this.form = this.querySelector('form') || this.closest('form') || document.querySelector('form[action*="/cart/add"]');
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      
        // Desactiva el botón inicialmente
        this.submitButton.classList.add('disabled');
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.form.querySelector('[name="id"]').value = '';
      
        const productJsonScript = document.querySelector('script[id^="ProductJson-"]');
        if (!productJsonScript) {
          console.error('❌ No se encontró el JSON del producto');
          return;
        }
      
        const productData = JSON.parse(productJsonScript.textContent);
        const variants = productData.variants;
      
        const normalize = str => str.toLowerCase().replace('talla', '').trim();
      
        const initializeSizeInputs = () => {
          const inputs = document.querySelectorAll('input[type="radio"][name="Size"], input[type="radio"][name="Talla"], input[type="radio"][name="Taille"], input[type="radio"][name="Tamanho"]');
          if (!inputs.length) {
            console.warn('⏳ Esperando aparición de radios "Size"...');
            return false;
          }
      
          console.log(`✅ Detectados ${inputs.length} radios "Size"`);
      
          inputs.forEach(input => {
            const label = normalize(input.value);
            const match = variants.find(v => normalize(v.option2 || '') === label);
            if (match) {
              input.dataset.variantId = match.id;
              console.log(`🎯 Asignado variantId=${match.id} a "${input.value}"`);
            } else {
              console.warn(`⚠️ No se encontró variante para: "${input.value}"`);
            }
          });
      
          inputs.forEach(input => {
            input.addEventListener('change', () => {
              const variantId = input.dataset.variantId;
              const idInput = this.form.querySelector('input[name="id"]');
          
              if (!variantId) {
                idInput.value = '';
                return;
              }
          
              idInput.value = variantId;
              idInput.disabled = false;
              
              // Verificar variante seleccionada
              const selectedVariant = variants.find(v => v.id == variantId);
              
              // Mostrar u ocultar botón de "Avísame"
              setTimeout(() => {
              const selectedVariant = variants.find(v => v.id == variantId);
              const bisButton = document.getElementById('BIS_trigger');
            
              if (bisButton) {
                if (selectedVariant && !selectedVariant.available) {
                  // Mostrar botón de aviso
                  bisButton.hidden = false;
                  bisButton.style.setProperty('display', 'block', 'important');
                  bisButton.style.setProperty('visibility', 'visible', 'important');
                  bisButton.style.setProperty('opacity', '1', 'important');
                  bisButton.style.setProperty('pointer-events', 'auto', 'important');
                  bisButton.style.setProperty('z-index', '10', 'important');
                  bisButton.removeAttribute('hidden');
                  bisButton.dataset.variantId = variantId;
            
                  // Proteger con observer
                  if (!bisButton._observerAttached) {
                    const observer = new MutationObserver(() => {
                      const computed = getComputedStyle(bisButton);
                      if (computed.display === 'none') {
                        bisButton.style.setProperty('display', 'block', 'important');
                        bisButton.style.setProperty('visibility', 'visible', 'important');
                        bisButton.style.setProperty('opacity', '1', 'important');
                        bisButton.style.setProperty('pointer-events', 'auto', 'important');
                        bisButton.style.setProperty('z-index', '10', 'important');
                      }
                    });
                    observer.observe(bisButton, { attributes: true, attributeFilter: ['style'] });
                    bisButton._observerAttached = true;
                  }
            
                  // También desactivar botón de añadir al carrito
                  const existingBtn = this.form.querySelector('button[type="submit"]');
                  if (existingBtn) {
                    existingBtn.setAttribute('disabled', 'disabled');
                    existingBtn.setAttribute('aria-disabled', 'true');
                    existingBtn.classList.add('disabled');
                    existingBtn.style.pointerEvents = 'none';
                    existingBtn.style.opacity = '0.5';
                    existingBtn.style.cursor = 'not-allowed';
                  }
            
                } else {
                    requestAnimationFrame(() => {
                      if (!selectedVariant.available) return; // por seguridad extra
                  
                      // Ocultar con máxima prioridad
                      bisButton.setAttribute('hidden', true);
                      bisButton.removeAttribute('data-variant-id');
                      bisButton.style.setProperty('display', 'none', 'important');
                      bisButton.style.setProperty('visibility', 'hidden', 'important');
                      bisButton.style.setProperty('opacity', '0', 'important');
                      bisButton.style.setProperty('pointer-events', 'none', 'important');
                      bisButton.style.setProperty('z-index', '-1', 'important');
                  
                      // ✅ Anula posibles cambios de scripts externos
                      const clone = bisButton.cloneNode(true);
                      bisButton.parentNode.replaceChild(clone, bisButton);
                    });
                  }

              }
            }, 0);

              
              // Si no hay stock, detener flujo aquí
              if (!selectedVariant || !selectedVariant.available) {
                console.log('⛔ Variante sin stock. Se muestra botón de aviso.');
              
                // Desactivar botón de añadir al carrito si ya existe
                const existingBtn = this.form.querySelector('button[type="submit"]');
                if (existingBtn) {
                  existingBtn.setAttribute('disabled', 'disabled');
                  existingBtn.setAttribute('aria-disabled', 'true');
                  existingBtn.classList.add('disabled');
                  existingBtn.style.pointerEvents = 'none';
                  existingBtn.style.opacity = '0.5';
                  existingBtn.style.cursor = 'not-allowed';
                }
              
                return;
              }



              // Eliminar botón original
              const oldBtn = this.form.querySelector('button[type="submit"]');
              const btnWrapper = oldBtn?.parentNode;
          
              if (!oldBtn || !btnWrapper) return;
          
              // Crear botón funcional
              const newBtn = document.createElement('button');
              newBtn.type = 'submit';
              newBtn.className = oldBtn.className;
              newBtn.innerHTML = oldBtn.innerHTML;
              newBtn.style.pointerEvents = 'auto';
              newBtn.style.opacity = '1';
              newBtn.style.cursor = 'pointer';
          
              // Eliminar viejo y añadir nuevo
              btnWrapper.replaceChild(newBtn, oldBtn);
          
              // Listener para enviar
              newBtn.addEventListener('click', (e) => {
                e.preventDefault();
              
                if (!idInput.value) {
                  const modal = document.getElementById('variant-error-modal');
                  if (modal) modal.classList.remove('hidden');
                  return;
                }
              
                // Envío nativo para que apps como Infinite Options funcionen bien
                this.form.requestSubmit();
              });


          
              console.log(`🟢 Botón funcional creado para variantId: ${variantId}`);
            });
          });

          const btn = this.form.querySelector('button[type="submit"]');
          const idInput = this.form.querySelector('input[name="id"]');
          
          if (btn && !btn.dataset.listenerAttached) {
            btn.addEventListener('click', async (e) => {
              e.preventDefault();
          
              const variantId = idInput.value;
              if (!variantId) {
                const modal = document.getElementById('variant-error-modal');
                if (modal) modal.classList.remove('hidden');
                return;
              }
          
              try {
                const formData = new FormData(this.form);
          
                const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  body: formData,
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                  }
                });
          
                if (response.ok) {
                  console.log('✅ Producto añadido al carrito');
                  
                  // Dirije al carrito según idioma
                  const lang = document.documentElement.lang || 'es';
                  const langPrefix = ['es', 'en', 'fr', 'pt-PT'].includes(lang) ? (lang === 'es' ? '' : `/${lang.split('-')[0]}`) : '';
                  window.location.href = `${langPrefix}/cart`;
                  
                } else {
                  const error = await response.json();
                  console.error('❌ Error al añadir al carrito:', error);
                  alert('No se pudo añadir al carrito: ' + (error.description || error.message));
                }
          
              } catch (err) {
                console.error('❌ Error inesperado:', err);
              }
            });
          
            btn.dataset.listenerAttached = "true";
          }

      
          const preselected = this.form.querySelector('input[type="radio"][name="Size"]:checked, input[type="radio"][name="Talla"]:checked, input[type="radio"][name="Taille"]:checked, input[type="radio"][name="Tamanho"]:checked');
          if (preselected) preselected.dispatchEvent(new Event('change'));
      
          return true;
        };
      
        if (!initializeSizeInputs()) {
          const observer = new MutationObserver(() => {
            if (initializeSizeInputs()) observer.disconnect();
          });
          observer.observe(this.form, { childList: true, subtree: true });
        }
      
        this.form.addEventListener('submit', (event) => {
          const variantId = this.form.querySelector('input[name="id"]').value;
          if (!variantId) {
            event.preventDefault();
            const modal = document.getElementById('variant-error-modal');
            if (modal) modal.classList.remove('hidden');
            return;
          }
        });

        // 🌐 Traducir contenido del modal según el idioma
        const modalMessage = document.querySelector('.variant-error-modal__message');
        const modalCloseBtn = document.getElementById('variant-error-close');
        if (modalMessage || modalCloseBtn) {
          const lang = document.documentElement.lang || 'es';
        
          const messages = {
            es: 'Por favor, selecciona una talla antes de añadir al carrito.',
            en: 'Please select a size before adding to the cart.',
            fr: 'Veuillez sélectionner une taille avant d\'ajouter au panier.',
            'pt-PT': 'Por favor, selecione um tamanho antes de adicionar ao carrinho.'
          };
        
          const buttonLabels = {
            es: 'Aceptar',
            en: 'OK',
            fr: 'OK',
            'pt-PT': 'OK'
          };
        
          if (modalMessage) modalMessage.textContent = messages[lang] || messages['es'];
          if (modalCloseBtn) modalCloseBtn.textContent = buttonLabels[lang] || buttonLabels['es'];
        }

      
        const closeBtn = document.getElementById('variant-error-close');
        const modal = document.getElementById('variant-error-modal');
        if (closeBtn && modal) {
          closeBtn.addEventListener('click', () => modal.classList.add('hidden'));
          modal.addEventListener('click', (e) => {
            if (e.target === modal || e.target.classList.contains('variant-error-modal__overlay')) {
              modal.classList.add('hidden');
            }
          });
        }
      }

    });
  }
});
